<div class="lum-page lum-page__card lum-c-order-transfer">
  <div
    class="overlay"
    lumAppLoader
    [loading]="(submitting$ | async) || (loading$ | async) || false"
    [classes]="'loading blur'"
  ></div>

  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">Transfer Orders</h2>
    <div class="lum-page-header__actions">
      <button
        class="lum-button"
        mat-button
        [routerLink]="['/inventory/transfer-order/create']"
      >
        <lum-ui-icon
          icon="add-circle"
          color="#ffffff"
          width="20"
          height="20"
        ></lum-ui-icon>
        <span>Add New Transfer Order</span>
      </button>
    </div>
  </header>

  <div class="lum-page-content">
    <div class="lum-filters__container row">
      <div class="col-md-10">
        <lum-filter
          filterId="transfer-order-filters"
          buttonClass="lum-button--secondary"
          buttonIconColor="#5563d6"
          [filters]="filters"
          (queryBuildEvent)="onQueryBuild($event)"
        ></lum-filter>
      </div>
      <div class="col-md-2">
        <div class="lum-filter-actions__container grow-0 shrink-0 pl-2">
          <button
            type="button"
            class="lum-button lum-button--secondary ml-auto"
            [matMenuTriggerFor]="menu"
          >
            Columns ({{ displayColumnCount }})
          </button>

          <mat-menu class="lum-mat-menu" #menu="matMenu">
            <ng-container
              *ngFor="let column of displayColumns; trackBy: trackByValue"
            >
              <mat-checkbox
                #menuItems
                class="lum-checkbox lum-checkbox--menu  d-block py-3 hover:gray-100"
                name="menu_filters"
                [checked]="column.visible"
                (change)="onSelectColumn($event, column)"
                (click)="$event.stopPropagation()"
              >
                {{ column.label }}
              </mat-checkbox>
            </ng-container>
          </mat-menu>
        </div>
      </div>
    </div>

    <lum-order-transfer-table
      [columns]="columns"
      [orderTransfers]="(orderTransfers$ | async) || []"
      (deleteOrderEvent)="onDeleteTransferOrder($event)"
    ></lum-order-transfer-table>

    <mat-paginator
      [length]="(pagination$ | async)?.total"
      [pageSize]="(pagination$ | async)?.per_page"
      [pageSizeOptions]="paginationConfig.pageSizeOptions"
      [pageIndex]="((pagination$ | async)?.current_page || 1) - 1"
      (page)="onPaginationEvent($event)"
      aria-label="Select page"
      class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
    >
    </mat-paginator>
  </div>
</div>
